import styled from '@emotion/styled';
import { fontSize } from 'src/assets/fonts-config';
import { fraudAndComplianceColors } from 'src/assets/colors';
import { DateTimeInput } from 'src/components/DateTimeInput/DateTimeInput';
import { Input } from 'src/domains/common/components/input/input';

export const MarkersOfHarmWrapper = styled('div', { label: 'MarkersOfHarmWrapper' })`
    border: 1px solid #ccc;
    margin: 30px 0 0 0;
    padding: 10px;
    min-height: 525px;
    overflow-x: auto;
`;

export const InteractionWrapper = styled('div', { label: 'InteractionWrapper' })`
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
    min-width: 905px;
`;

export const InteractionTypeWrapper = styled('div', { label: 'InteractionTypeWrapper' })`
    width: 13%;
`;

export const EmptyInteractionWrapper = styled('div', { label: 'EmptyInteractionWrapper' })`
    height: 105px;
`;
export interface InteractionWrapperType {
    type: 'inline' | 'headLine';
}
export const DateInputWrapper = styled('div', { label: 'DateInputWrapper' })<InteractionWrapperType>`
    display: ${({ type }):string => type === 'headLine' ? 'flex': 'initial'};
    flex-direction: column;
    justify-content: space-between;
`;

export const NextReviewDateLabel = styled('span', { label: 'NextReviewDateLabel' })`
    font-size: ${fontSize.xRegular};
    line-height: 1.5;
    padding: 0 0 5px 5px;
`;

export const InputNoteWrapper = styled('div', { label: 'InputNoteWrapper' })`
    width: 24%;
`;

export const ReasonWrapper = styled('div', { label: 'ReasonWrapper' })`
    width: 20%;
`;

export const RiskWrapper = styled('div', { label: 'RiskWrapper' })`
    width: 10%;
`;

export const StatusWrapper = styled('div', { label: 'StatusWrapper' })`
    width: 10%;
`;

export const ProfitLossWrapper = styled('div', { label: 'ProfitLossWrapper' })`
    width: 10%;
`;

export const ButtonsWrapper = styled('div', { label: 'ButtonsWrapper' })`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const ButtonWrapper = styled('div', { label: 'ButtonWrapper' })`
    margin: 25px 0 0 0;
`;

export const TableRow = styled('tr', { label: 'TableRow' })`
    &:nth-child(odd) {
        background-color: ${fraudAndComplianceColors.commonTable.bgColorRowOtherFirst};
    }

    &:nth-child(even) {
        background-color: ${fraudAndComplianceColors.commonTable.bgColorRowOtherSecond};
    }
`;

export const DataTimeInputWrapper = styled(DateTimeInput, { label: 'DataTimeInputWrapper' })`
    input {
        background-color: transparent;
        border-radius: 6px;
        border-color: rgb(228, 228, 231);
        border-style: solid;
        line-height: 1.5;
        font-size: 14px;
        padding: 6px 12px;
        min-width: 150px;
    }
`;

export const NoMarkersInfo = styled('div', { label: 'NoMarkersInfo' })`
    position: absolute;
    margin: 20px 12px;
`;

export const InputInlineWrapper = styled(Input, { label: 'InputInlineWrapper' })`
    background-color: transparent;
`;
